import React from 'react';

const ThumbnailBg = ({ color = '#504EB9', hasEducatorImg = true }) => {
  return (
    <svg
      width="720"
      height="472"
      viewBox="0 0 720 472"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1488_474655)">
        <rect
          width="720"
          height="472"
          rx="7.21989"
          fill={color}
          fillOpacity="0.25"
        />
        <g
          style={{ mixBlendMode: 'color-burn' }}
          filter="url(#filter0_f_1488_474655)"
        >
          <path
            d="M831.046 -202.768C693.1 248.925 381.573 564.138 -350.237 781.441H1194.51V-202.768H831.046Z"
            fill="url(#paint0_linear_1488_474655)"
            fillOpacity="0.2"
          />
        </g>
        <g filter="url(#filter1_f_1488_474655)">
          <circle
            cx="19.5012"
            cy="236.001"
            r="323.501"
            fill="white"
            fillOpacity="0.3"
          />
        </g>
        {hasEducatorImg && (
          <g opacity="0.3" filter="url(#filter2_f_1488_474655)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M101.902 115.058C141.898 122.203 165.174 171.329 153.89 224.784C151.477 236.211 147.681 246.91 142.812 256.601C161.129 278.28 175.602 306.969 183.15 339.87C201.874 421.48 170.904 498.107 113.977 511.02C57.0503 523.933 -4.27664 468.243 -23.0004 386.632C-36.7636 326.642 -23.676 269.346 6.83481 238.068C5.55049 225.7 6.19211 212.443 9.04922 198.909C20.3337 145.455 61.9051 107.913 101.902 115.058Z"
              fill={color}
            />
          </g>
        )}
        {!hasEducatorImg && (
          <g opacity="0.4">
            <path
              d="M28 274.8C28 324.268 68.2944 364.371 118 364.371C167.706 364.371 208 324.268 208 274.8V268.491C208 264.378 204.65 261.044 200.517 261.044H35.4826C31.3501 261.044 28 264.378 28 268.491V274.8Z"
              fill={color}
              fillOpacity="0.5"
            />
            <path
              d="M69.4641 199.144C69.4641 225.734 91.1943 247.289 118 247.289C144.805 247.289 166.536 225.734 166.536 199.144C166.536 172.555 144.805 151 118 151C91.1943 151 69.4641 172.555 69.4641 199.144Z"
              fill={color}
              fillOpacity="0.5"
            />
            <path
              d="M147.771 281.34C148.661 286.877 153.554 291.112 159.456 291.112C165.298 291.112 170.151 286.962 171.112 281.507C171.235 280.995 171.286 280.586 171.271 280.236C171.271 279.834 170.977 279.522 170.57 279.522H148.352C147.945 279.522 147.652 279.834 147.651 280.235C147.65 280.235 147.652 280.235 147.651 280.235C147.652 280.244 147.65 280.253 147.65 280.262C147.64 280.567 147.679 280.917 147.771 281.34Z"
              fill="white"
            />
            <path
              d="M165.263 298.403C164.818 295.634 162.372 293.517 159.421 293.517C156.5 293.517 154.073 295.592 153.593 298.319C153.531 298.575 153.506 298.78 153.513 298.955C153.513 299.156 153.66 299.312 153.864 299.312H164.973C165.176 299.312 165.323 299.156 165.323 298.955C165.323 298.955 165.324 298.955 165.323 298.955C165.323 298.951 165.324 298.946 165.324 298.942C165.329 298.789 165.309 298.614 165.263 298.403Z"
              fill="white"
            />
          </g>
        )}
      </g>
      <defs>
        <filter
          id="filter0_f_1488_474655"
          x="-449.778"
          y="-302.309"
          width="1743.83"
          height="1183.29"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="49.7705"
            result="effect1_foregroundBlur_1488_474655"
          />
        </filter>
        <filter
          id="filter1_f_1488_474655"
          x="-318.44"
          y="-101.94"
          width="675.882"
          height="675.882"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="7.21989"
            result="effect1_foregroundBlur_1488_474655"
          />
        </filter>
        <filter
          id="filter2_f_1488_474655"
          x="-49.4669"
          y="93.1811"
          width="259.084"
          height="440.704"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.5025"
            result="effect1_foregroundBlur_1488_474655"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1488_474655"
          x1="633.921"
          y1="454.74"
          x2="1092.36"
          y2="-101.168"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor={color} stopOpacity="0.5" />
        </linearGradient>
        <clipPath id="clip0_1488_474655">
          <rect width="720" height="472" rx="7.21989" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ThumbnailBg;
